import {
    Box,
    Button,
    createListCollection,
    Field,
    Flex,
    Grid,
    GridItem,
    Image,
    Input,
    InputGroup,
    Link,
    Select,
    Spinner,
    Stack,
    Switch,
    Text,
} from "@chakra-ui/react";
import { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { usePostFormMutation } from "@/hooks/microservicesApi";

const FormReferido = ({ onClose, onOpen, setTitle, setStatus, setMessage, optionsDevelops }) => {
    const [refererName, setRefererName] = useState("");
    const [refererEmail, setRefererEmail] = useState("");
    const [refererPhone, setRefererPhone] = useState("");
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [developmentName, setDevelopmentName] = useState("");
    const [adviser, setAdviser] = useState(false);
    const [adviserName, setAdviserName] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const developsCollections = createListCollection({
        items: optionsDevelops,
    });

    const [postForm] = usePostFormMutation();

    const handleSubmit = () => {
        setIsLoading(true);
        let hasAdviser = false;
        if (adviser) {
            hasAdviser = "Si";
        } else {
            hasAdviser = "No";
        }
        const data = {
            id: "337b3e74-9b7b-4fb2-976a-4c6f914fb510",
            body: {
                fields: [
                    {
                        name: "nombre_referidor",
                        value: refererName,
                    },
                    {
                        name: "correo_de_referidor",
                        value: refererEmail,
                    },
                    {
                        name: "telefono_de_referidor",
                        value: refererPhone,
                    },
                    {
                        name: "firstname",
                        value: name,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: phone,
                    },
                    {
                        name: "desarrollo",
                        value: developmentName,
                    },
                    {
                        name: "ya_estas_siendo_atendido_por_un_asesor_",
                        value: hasAdviser,
                    },
                    {
                        name: "message",
                        value: adviserName,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx",
                    pageName: "Grupo Guia | Referidos",
                },
            },
        };
        postForm(data)
            .then((resp) => {
                setIsLoading(false);
                setRefererName("");
                setRefererEmail("");
                setRefererPhone("");
                setName("");
                setEmail("");
                setPhone("");
                setDevelopmentName("");
                setAdviser(false);
                setAdviserName("");
                setTitle("¡La información ha sido enviada con éxito!");
                setStatus("success");
                setMessage("¡Gracias por contactarnos!");
                onClose();
                onOpen();
            })
            .catch((error) => {
                setIsLoading(false);
                setTitle("¡Lo sentimos, hubo un error!");
                setStatus("error");
                setMessage("¡Hubo un error al enviar tu solicitud, por favor intenta nuevamente!");
                onClose();
                onOpen();
                console.error("Error: ", error);
            });
    };

    return (
        <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit();
            }}
        >
            <Grid gridTemplateColumns="repeat(2, 1fr)" gap={6} my={4} color="black">
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <Field.Root variant="floating" id="nombre_referidor" required>
                        <Input
                            rounded="full"
                            placeholder=" "
                            p={4}
                            fontSize="sm"
                            value={refererName}
                            onChange={(e) => {
                                e.preventDefault();
                                setRefererName(e.target.value);
                            }}
                        />
                        <Field.Label color="#4F4F4F4F" ml={4}>
                            Nombre del referidor
                        </Field.Label>
                    </Field.Root>
                </GridItem>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <Field.Root variant="floating" id="correo_referidor" required>
                        <Input
                            rounded="full"
                            placeholder=" "
                            p={4}
                            fontSize="sm"
                            value={refererEmail}
                            type="email"
                            onChange={(e) => {
                                e.preventDefault();
                                setRefererEmail(e.target.value);
                            }}
                        />
                        <Field.Label color="#4F4F4F4F" ml={4}>
                            Correo del referidor
                        </Field.Label>
                    </Field.Root>
                </GridItem>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <InputGroup
                        startAddon={
                            <Flex px={2}>
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                    width="4"
                                    height="4"
                                    alt="mexico"
                                    ml={1}
                                />
                                <Text fontSize="xs" fontWeight={500} mx="1" color="gray.600">
                                    +52
                                </Text>
                            </Flex>
                        }
                        startAddonProps={{
                            borderLeftRadius: "24px",
                            backgroundColor: "#FFFFFF",
                            borderColor: "gray.300",
                            borderRightWidth: "0",
                            borderWidth: "1px",
                        }}
                    >
                        <Field.Root variant="floating" id="telefono_referidor" required>
                            <Input
                                placeholder=" "
                                type="number"
                                p={4}
                                fontSize="sm"
                                borderLeftRadius={0}
                                borderRightRadius="full"
                                value={refererPhone}
                                onChange={(e) => {
                                    e.preventDefault();
                                    setRefererPhone(e.target.value);
                                }}
                            />
                            <Field.Label color="#4F4F4F4F">Teléfono del referidor</Field.Label>
                        </Field.Root>
                    </InputGroup>
                </GridItem>
            </Grid>
            <Stack my={0} alignItems="center" textAlign="center">
                <Text fontWeight={700} fontSize="md">
                    Datos del cliente Referido
                </Text>
            </Stack>
            <Grid gridTemplateColumns="repeat(2, 1fr)" gap={6} my={4}>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <Field.Root variant="floating" id="nombre_referido" required>
                        <Input
                            rounded="full"
                            placeholder=" "
                            p={4}
                            fontSize="sm"
                            value={name}
                            onChange={(e) => {
                                e.preventDefault();
                                setName(e.target.value);
                            }}
                        />
                        <Field.Label color="#4F4F4F4F" ml={4}>
                            Nombre
                        </Field.Label>
                    </Field.Root>
                </GridItem>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <Field.Root variant="floating" id="correo_referido" required>
                        <Input
                            rounded="full"
                            placeholder=" "
                            p={4}
                            fontSize="sm"
                            type="email"
                            value={email}
                            onChange={(e) => {
                                e.preventDefault();
                                setEmail(e.target.value);
                            }}
                        />
                        <Field.Label color="#4F4F4F4F" ml={4}>
                            Correo
                        </Field.Label>
                    </Field.Root>
                </GridItem>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <InputGroup
                        startAddon={
                            <Flex px={2}>
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                    width="4"
                                    height="4"
                                    alt="mexico"
                                    ml={1}
                                />
                                <Text fontSize="xs" fontWeight={500} mx="1" color="gray.600">
                                    +52
                                </Text>
                            </Flex>
                        }
                        startAddonProps={{
                            borderLeftRadius: "24px",
                            backgroundColor: "#FFFFFF",
                            borderColor: "gray.300",
                            borderRightWidth: "0",
                            borderWidth: "1px",
                        }}
                    >
                        <Field.Root variant="floating" id="telefono_referido" required>
                            <Input
                                placeholder=" "
                                type="number"
                                p={4}
                                fontSize="sm"
                                borderLeftRadius={0}
                                borderRightRadius="full"
                                value={phone}
                                onChange={(e) => {
                                    e.preventDefault();
                                    setPhone(e.target.value);
                                }}
                            />
                            <Field.Label color="#4F4F4F4F">Teléfono</Field.Label>
                        </Field.Root>
                    </InputGroup>
                </GridItem>
                <GridItem colSpan={{ base: 2, md: 1 }}>
                    <Field.Root
                        variant="floating"
                        id="tiene_asesor"
                        _disabled={{ bg: "gray.400" }}
                        required
                    >
                        <Select.Root
                            collection={developsCollections}
                            rounded="full"
                            onValueChange={(details) => setDevelopmentName(details.value[0])}
                        >
                            <Select.HiddenSelect />
                            <Select.Control>
                                <Select.Trigger ml={4} rounded="full">
                                    <Select.ValueText
                                        overflowWrap="break-word"
                                        whiteSpace="normal"
                                        color="gray.600"
                                    />
                                </Select.Trigger>
                                <Select.IndicatorGroup pr={4}>
                                    <Select.Indicator />
                                </Select.IndicatorGroup>
                            </Select.Control>

                            <Select.Positioner>
                                <Select.Content p={2}>
                                    {developsCollections?.items.map((option) => (
                                        <Select.Item
                                            item={option}
                                            key={option.value}
                                            color="gray.600"
                                            p={1}
                                        >
                                            {option.label}
                                            <Select.ItemIndicator />
                                        </Select.Item>
                                    ))}
                                </Select.Content>
                            </Select.Positioner>
                        </Select.Root>
                        <Field.Label color="#4F4F4F4F" ml={4}>
                            Desarrollo de interés
                        </Field.Label>
                    </Field.Root>
                </GridItem>
            </Grid>
            <Box mt={7}>
                <Text>¿Cuentas con un asesor de Grupo Guia?</Text>
                <Field.Root id="adviser">
                    <Switch.Root
                        mt={2}
                        size="lg"
                        checked={adviser}
                        onCheckedChange={(details) => setAdviser(details.checked)}
                    >
                        <Switch.HiddenInput />
                        <Switch.Control />
                        <Switch.Label />
                    </Switch.Root>
                </Field.Root>
            </Box>
            <Box mt={5} mb={2} display={adviser ? "block" : "none"}>
                <Field.Root variant="floating" id="nombre_asesor">
                    <Input
                        rounded="full"
                        placeholder=" "
                        p={4}
                        fontSize="sm"
                        value={adviserName}
                        onChange={(e) => {
                            e.preventDefault();
                            setAdviserName(e.target.value);
                        }}
                    />
                    <Field.Label color="#4F4F4F4F" ml={4}>
                        Nombre del asesor
                    </Field.Label>
                </Field.Root>
            </Box>
            <Stack textAlign="center" justifyContent="center" my={4} alignSelf="center">
                <Checkbox required alignSelf="center" colorPalette="blue">
                    Acepto los{" "}
                    <Link
                        href="terminosycondiciones-guiaconnect"
                        color="blue"
                        textDecoration="underline"
                        external
                    >
                        Términos y condiciones.
                    </Link>
                </Checkbox>
            </Stack>
            <Stack alignItems="center" pt={5}>
                <Button
                    rounded="full"
                    w={{ base: "100%", md: "50%" }}
                    fontWeight="500"
                    color="black"
                    px={12}
                    type="submit"
                    disabled={isLoading}
                    bg="brand.500"
                >
                    <Spinner
                        size="sm"
                        color="gray.500"
                        display={isLoading ? "inline-flex" : "none"}
                        mr={2}
                    />
                    {isLoading ? "Enviando..." : "Enviar"}
                </Button>
            </Stack>
        </form>
    );
};

export default FormReferido;
